<div class="loading-overlay">
    <div class="loading-popup">
        <div class="popup-header">
            <div class="logo-section">
                <img src="assets/img/phoenix-1.png" alt="Phoenix" class="phoenix-logo" />
                <div class="logo-text">
                    <span class="logo-title">Phoenix</span>
                    <span class="logo-subtitle">Enhancing Silver Value</span>
                </div>
            </div>
        </div>
        
        <div class="popup-content">
            <div class="loading-spinner">
                <div class="spinner-ring"></div>
                <div class="spinner-ring"></div>
                <div class="spinner-ring"></div>
                <div class="spinner-ring"></div>
                <div class="spinner-ring"></div>
                <div class="spinner-ring"></div>
                <div class="spinner-ring"></div>
                <div class="spinner-ring"></div>
            </div>
            
            <div class="loading-message">
                <p>Estamos procesando tu información <strong>{{ userName }}</strong>, creando tu diagnóstico personalizado.</p>
            </div>
        </div>
    </div>
</div>